import { Inject, Injectable, Optional, SkipSelf } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

import { TypeHabilitationTLR } from "../entities/type-habilitation-tlr.entity";
import { TypeHabilitationWithQualCodesDTO } from "../entities/type-habilitation-with-qual-codes-dto.entity";

@Injectable({ providedIn: 'root' })
export class TypeHabilitationService {
	private path: string;

	constructor( //
		@Inject(HttpClient) private httpClient: HttpClient, //
		@Optional() @SkipSelf() previousInstance?: TypeHabilitationService //
	) {
		if (previousInstance) {
			throw new Error(
				'IntervenantService is already loaded. Import it in the AppModule only');
		}
		this.path = (window as any).baseApiPath;
	}
	
	// NB: plus utilise, mais garde en reserve au cas ou on aurait besoin de recuperer un jour de simples TLR
	public getByIntervenant(idIntervenant: number): Observable<TypeHabilitationTLR[]> {
		let url = this.path + "intervenant/" + idIntervenant + "/types-habilitations";
		let result = this.httpClient.get<TypeHabilitationTLR[]>(url);
		return result;
	}
	
	public getWithQualCodesByIntervenant(idIntervenant: number, onlyActives: boolean): Observable<TypeHabilitationWithQualCodesDTO[]> {
		let url = this.path + "intervenant/" + idIntervenant + "/types-habilitations?format=withQualCodes";
		if (onlyActives) {
			url += "&onlyActives=true";
		}
		let result = this.httpClient.get<TypeHabilitationWithQualCodesDTO[]>(url);
		return result;
	}
}